import React from "react";
import { Camera } from "lucide-react";

const IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1633014041037-f5446fb4ce99?w=900&q=60&fm=jpg&fit=crop",
    alt: "Car wash water splash",
    className: "col-span-2 row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1565689876697-e467b6c54da2?w=500&q=60&fm=jpg&fit=crop",
    alt: "Car being washed",
    className: "col-span-1 row-span-1",
  },
  {
    url: "https://images.pexels.com/photos/17029940/pexels-photo-17029940.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=400&w=400",
    alt: "Car detail work",
    className: "col-span-1 row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?w=900&q=60&fm=jpg&fit=crop",
    alt: "High-pressure car wash",
    className: "col-span-3 row-span-1",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#a8d8ea]/30 text-[#1a2744] rounded-full px-4 py-2 text-sm font-bold mb-4 border border-[#a8d8ea]/30">
            <Camera size={15} strokeWidth={2.5} className="text-[#c0392b]" />
            Our Work
          </div>
          <h2
            className="text-4xl sm:text-5xl font-bold text-[#1a2744]"
            style={{ fontFamily: "Fredoka, sans-serif" }}
            data-testid="gallery-heading"
          >
            See the Shine
          </h2>
          <p className="text-[#1a2744]/60 text-base sm:text-lg mt-3">
            Real results from real customers — every single time
          </p>
        </div>

        <div
          className="grid grid-cols-3 gap-4"
          style={{ gridAutoRows: "200px" }}
        >
          {IMAGES.map((img, i) => (
            <div
              key={i}
              className={`${img.className} rounded-3xl overflow-hidden group cursor-pointer bg-[#a8d8ea]/20`}
              data-testid={`gallery-image-${i + 1}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-105 opacity-0"
                onLoad={(e) => (e.target.style.opacity = "1")}
                style={{ transition: "opacity 0.5s ease, transform 0.5s ease" }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
